import { useState, useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toggleFollowUserApi } from "../../../api/resources.api";

export const useFollowUser = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const queryClient = useQueryClient();

  const toggleFollowUser = useCallback(
    async (id: number) => {
      try {
        setLoading(true);
        setError(null);

        const response = await toggleFollowUserApi(id);

        if (response?.success) {
          queryClient.invalidateQueries({
            queryKey: ["follow-check", "persons", id],
          });

          return {
            isFollowing: response.is_following,
            followersCount: response.followers_count,
            message: response.message,
          };
        }

        setError(response?.message || "خطا در انجام عملیات");
        return null;
      } catch (err) {
        setError("خطا در ارتباط با سرور");
        return null;
      } finally {
        setLoading(false);
      }
    },
    [queryClient],
  );

  return {
    toggleFollowUser,
    loading,
    error,
    reset: () => setError(null),
  };
};
